// The base no-unused-vars rule does not see type-only uses.
/* eslint no-unused-vars: "off", "@typescript-eslint/no-unused-vars": "warn" */
import React from 'react';
import { FormField, Input, Textarea } from '@amzn/awsui-components-react-v3/polaris';
import * as goldenDatasets from './goldenDatasets';

const FIELDS = {
  name: {
    ariaLabel: 'Name',
    constraintText: `Required. At most ${goldenDatasets.NAME_MAX} characters.`,
    validate: goldenDatasets.validateName,
  },
  description: {
    ariaLabel: 'Description',
    constraintText: `Required. At most ${goldenDatasets.DESCRIPTION_MAX} characters.`,
    validate: goldenDatasets.validateDescription,
  },
};

interface DatasetMetadataFieldProps {
  field: goldenDatasets.MetadataField;
  values: goldenDatasets.Metadata;
  // Shown in place of the field's own check, e.g. Pricing's 422 for it.
  serverError?: string;
  // Omitted where the surrounding layout labels the field.
  label?: string;
  disabled: boolean;
  onChange: (values: goldenDatasets.Metadata) => void;
}

/** A dataset's name or description input with its limits. */
export const DatasetMetadataField = ({
  field,
  values,
  serverError,
  label,
  disabled,
  onChange,
}: DatasetMetadataFieldProps): JSX.Element => {
  const { ariaLabel, constraintText, validate } = FIELDS[field];
  const error = serverError || validate(values[field]);
  const controlProps = {
    id: field,
    ariaLabel,
    value: values[field],
    invalid: Boolean(error),
    disabled,
    onChange: ({ detail }: { detail: { value: string } }): void =>
      onChange({ ...values, [field]: detail.value }),
  };
  return (
    <FormField
      id={`${field}-field`}
      label={label}
      constraintText={constraintText}
      errorText={error}
    >
      {field === 'name' ? <Input {...controlProps} /> : <Textarea {...controlProps} />}
    </FormField>
  );
};
